import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AutoUploadDiscoveryModal.css';

const AutoUploadDiscoveryModal = ({ enabled, onSetEnabled, onDismiss }) => {
  const navigate = useNavigate();

  const handleCustomize = () => {
    onDismiss?.();
    navigate('/settings#auto-upload');
  };

  const handleToggle = (event) => {
    onSetEnabled?.(event.target.checked);
  };

  return (
    <div className="auto-upload-discovery-overlay" onClick={onDismiss}>
      <div className="auto-upload-discovery-modal" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="auto-upload-discovery-close"
          onClick={onDismiss}
          aria-label="Close"
        >
          ×
        </button>
        <div className="auto-upload-discovery-badge">New</div>
        <h2>Auto-upload to Strava</h2>
        <p className="auto-upload-discovery-lead">
          Auto-upload is now live. Mythic will make a map for every new Strava activity, in the styles you love.
        </p>
        <ul className="auto-upload-discovery-bullets">
          <li>
            <span className="auto-upload-discovery-bullet-icon">⚡</span>
            <span>A new map is generated as soon as you log an activity.</span>
          </li>
          <li>
            <span className="auto-upload-discovery-bullet-icon">📤</span>
            <span>Maps are shared to your Strava activity automatically, no extra clicks.</span>
          </li>
          <li>
            <span className="auto-upload-discovery-bullet-icon">🎁</span>
            <span>Auto-uploaded maps are free.</span>
          </li>
          <li>
            <span className="auto-upload-discovery-bullet-icon">🎬</span>
            <span>Get a free transition video — your Strava map morphing into the generated artwork — with every upload.</span>
          </li>
          <li>
            <span className="auto-upload-discovery-bullet-icon">🎨</span>
            <span>Pick the styles in your mix, choose portrait or landscape, turn it off anytime.</span>
          </li>
        </ul>

        <div className="auto-upload-discovery-toggle-row">
          <span className="auto-upload-discovery-toggle-label">
            Auto-upload {enabled ? 'on' : 'off'}
          </span>
          <label className="toggle-switch">
            <input
              type="checkbox"
              checked={!!enabled}
              onChange={handleToggle}
            />
            <span className="toggle-slider" />
          </label>
        </div>

        <button
          type="button"
          className="auto-upload-discovery-customize"
          onClick={handleCustomize}
        >
          Customize styles and format
        </button>
      </div>
    </div>
  );
};

export default AutoUploadDiscoveryModal;
